/**
 * Wire-контракт обложки и подготовки загрузки (`Platform.Contracts/Catalog/CatalogPhotoDtos.cs`) и его проверка на границе: неожиданная форма —
 * `invalid-response`. Адреса `url`/`thumbUrl` ответа не используются: экран строит их сам из `PLATFORM_COMMON_PHOTO_URLS`.
 */
import { integer, optionalText, record, text } from '../../../shared/decode'
import type { MainPhotoRef } from '../../../shared/product'
import type { CropBox, PhotoPreparation } from '../model/types'

function decodeCropBox(raw: unknown, name: string): CropBox {
  const item = record(raw, name)
  return {
    left: integer(item.left, `${name}.left`),
    top: integer(item.top, `${name}.top`),
    right: integer(item.right, `${name}.right`),
    bottom: integer(item.bottom, `${name}.bottom`),
  }
}

/** `POST …/photos/staging/prepare` (`CatalogPhotoPreparationDto`, RP-FB73): вырез без фона и предложенная рамка. Неожиданная форма — `invalid-response`. */
export function decodePhotoPreparation(raw: unknown): PhotoPreparation {
  const item = record(raw, 'photo-preparation')
  return {
    cutoutBase64: text(item.cutoutBase64, 'photo-preparation.cutoutBase64'),
    contentType: text(item.contentType, 'photo-preparation.contentType'),
    width: integer(item.width, 'photo-preparation.width'),
    height: integer(item.height, 'photo-preparation.height'),
    proposedBox: decodeCropBox(item.proposedBox, 'photo-preparation.proposedBox'),
    cropStatus: text(item.cropStatus, 'photo-preparation.cropStatus'),
    cropStatusText: optionalText(item.cropStatusText, 'photo-preparation.cropStatusText'),
    margin: integer(item.margin, 'photo-preparation.margin'),
    maxSide: integer(item.maxSide, 'photo-preparation.maxSide'),
  }
}

/**
 * Обложка ОБЩЕГО товара в выдаче (`CatalogMainPhotoDto`, RP-FB70, PHI-13b): `photoId` и `kind` (`registry` | `staging`) — по ним строится адрес миниатюры, `thumbUrl` и `url`
 * ответа не используются (адреса строит один построитель). Нет поля, `null` — у общего товара фото нет, или сервер прежний.
 */
export function decodeMainPhoto(raw: unknown, name: string): MainPhotoRef | null {
  if (raw === null || raw === undefined) return null
  const item = record(raw, name)
  const kind = text(item.kind, `${name}.kind`)
  if (kind !== 'registry' && kind !== 'staging') throw new Error(`поле ${name}.kind — неизвестный вид обложки «${kind}»`)
  return { photoId: text(item.photoId, `${name}.photoId`), kind }
}

